// extracted by mini-css-extract-plugin
module.exports = {"field-box":"style_field-box__C7XA9"};